<template>
  <el-container>
    <el-header style="text-align: right; padding: 0 0;font-size: 12px">
      <el-menu
        :router="true"
        mode="horizontal"
        :default-active="active"
        style="padding: 0 20px 0 0"
        class="booth-menu">
        <el-menu-item style="float: left">
          <div class="header-logo"
            v-if="(user.organizationId && ['65b23697bdca81000429d10f', '66cdececce510e0004d3924e', '664aff26000bde0004e82244'].indexOf(user.organizationId) > -1)">
            <img style="width: 120px; margin-right: 10px;" src="../assets/images/title.png">
          </div>
          <div v-else>
            <img style="width: 40px; margin-right: 10px;" src="../assets/images/logo-blue.png"><span style="font-size: 20px" slot="title">{{$t('default.companyName')}}</span>
          </div>
        </el-menu-item>
        <el-menu-item>
          <el-button @click="signOut">{{ $t('default.signout') }}</el-button>
        </el-menu-item>
        <el-dropdown style="float: right" @command="changeLang">
          <span class="el-dropdown-link">
            {{langMap[lang]}}<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="chs">简体中文</el-dropdown-item>
            <el-dropdown-item command="tc">繁體中文</el-dropdown-item>
            <el-dropdown-item command="en">English</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-menu-item route="/work/resetpassword" index="/work/resetpassword">
          <span slot="title">{{$t('default.setting')}}</span>
        </el-menu-item>
        <el-menu-item route="/work/chart" index="/work/chart">
          <span slot="title">{{$t('default.chart')}}</span>
        </el-menu-item>
        <el-menu-item route="/work/organization" v-if="user.type === 'admin'" index="/work/organization">
          <span slot="title">{{$t('default.organization')}}</span>
        </el-menu-item>
        <el-menu-item v-if="user.type === 'admin'" route="/work/users" index="/work/users">
          <span slot="title">{{$t('default.users')}}</span>
        </el-menu-item>
        <el-menu-item route="/work/doctor_out" index="/work/doctor_out">
          <span slot="title">{{$t('default.reoprt')}}</span>
        </el-menu-item>
      </el-menu>
    </el-header>
    <el-container>
      <router-view></router-view>
    </el-container>
  </el-container>

</template>

<style lang="less" scoped>
.booth-menu {
  .el-menu-item {
    float: right;
  }
}
.el-aside {
  color: #333;
}
</style>

<script>
import { mapState } from 'vuex'
export default {
  data () {
    return {
      langMap: {
        chs: '简体中文',
        tc: '繁體中文',
        en: 'English'
      },
      lang: localStorage.getItem('lang') || 'tc'
    }
  },
  computed: {
    ...mapState({
      user: state => state.user
    }),
    active: function () {
      return this.$route.path
    }
  },
  mounted () {
  },
  methods: {
    changeLang (lang) {
      console.log(lang)
      this.$i18n.locale = lang
      this.lang = lang
      localStorage.setItem('lang', lang)
      window.location.reload()
    },
    signOut () {
      this.$confirm('确认退出登录? ')
        .then(_ => {
          localStorage.clear('token')
          localStorage.clear('tokenExpiredAt')
          global.defaultStore.commit('SIGNOUT')
          this.$router.push({ path: '/' })
        })
        .catch(_ => {})
    }
  }
}
</script>
